export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/logo-ups.bdd87218.svg","height":40,"width":35,"blurWidth":0,"blurHeight":0};